import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootswatch/dist/yeti/bootstrap.min.css'
import './index.css';
import { App } from './App';
import { ProSidebarProvider } from 'react-pro-sidebar';
import reportWebVitals from './reportWebVitals';
import { CasUserContextProvider } from './services/casUserContext';
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../src/helpers/EntraId/authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// root.render(
//   <React.StrictMode>
//       <ProSidebarProvider>
//         <CasUserContextProvider>
//          <App />
//         </CasUserContextProvider>
//       </ProSidebarProvider>   
//   </React.StrictMode>
// );

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ProSidebarProvider>
        <CasUserContextProvider>
          <App />
        </CasUserContextProvider>
      </ProSidebarProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
